export const SETUP_INSTRUCTION_LINK = 'https://docs.sentiance.com/faq/faq/security-and-privacy#how-to-set-up-mfa-for-logging-in-on-insights-as-a-business-user';
export const ERROR_CODES = {
    WEBHOOK_IP_ADDRESS_BLACKLISTED: 'E_IP_ADDRESS_BLACKLISTED',
    WEBHOOK_HTTP_NOT_ALLOWED: 'E_HTTP_NOT_ALLOWED',
    WEBHOOK_DNS_RESOLUTION_FAILURE: 'E_DNS_RESOLUTION_FAILURE'
}
